import { useTranslation } from 'react-i18next';
import { ContactFieldType } from '@dev/ee-api/ee-api-models';

export const useFieldTypes = () => {
    const { t } = useTranslation();

    return [
        {
            value: ContactFieldType.Text,
            label: t('text'),
        },
        {
            value: ContactFieldType.Number,
            label: t('number'),
        },
        {
            value: ContactFieldType.Date,
            label: t('date'),
        },
        {
            value: ContactFieldType.DateTime,
            label: t('datetime'),
        },
        {
            value: ContactFieldType.Currency,
            label: t('currency'),
        },
        {
            value: ContactFieldType.Boolean,
            label: t('boolean'),
        },
        {
            value: ContactFieldType.BigNumber,
            label: t('bignumber'),
        },
        {
            value: ContactFieldType.Date,
            label: t('date'),
        },
    ];
};
